import {
    GET_MACYS_ORDERS_REQUEST,
    GET_MACYS_ORDERS_SUCCESS,
    GET_MACYS_ORDERS_ERROR
} from "../actions/types"
export default function (state = null, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_MACYS_ORDERS_REQUEST:
            return {
                loading: true,
            };
        case GET_MACYS_ORDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_MACYS_ORDERS_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}